export default "__VITE_ASSET__029271ae__"